// Production hostnames
const PRODUCTION_HOSTNAMES = [
  'retrojet.app',
  'www.retrojet.app',
];

// Check if running in production
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
export const isProduction = 
  PRODUCTION_HOSTNAMES.includes(hostname) ||
  hostname.endsWith('.cloudfront.net') ||
  hostname.endsWith('.amazonaws.com');

// API URLs
export const API_BASE_URL = 
  import.meta.env.VITE_API_BASE_URL || 
  (isProduction ? 'https://api.retrojet.app' : 'http://localhost:3001');

export const WS_URL = 
  import.meta.env.VITE_WS_URL || 
  (isProduction ? 'wss://ws.retrojet.app' : 'ws://localhost:3001');

export const GOOGLE_CLIENT_ID = (import.meta.env.VITE_GOOGLE_CLIENT_ID || '').trim();
export const IS_GOOGLE_AUTH_ENABLED = GOOGLE_CLIENT_ID.length > 0;

export const config = {
  isProduction,
  apiBaseUrl: API_BASE_URL,
  wsUrl: WS_URL,
  googleClientId: GOOGLE_CLIENT_ID,
  isGoogleAuthEnabled: IS_GOOGLE_AUTH_ENABLED,
};
